export enum ReportEvents {
  PRESS_COPY_LINK_REPORT = "report_press_copy_link_report",
  STREAM_LOGS_IN_SYNC = "report_stream_logs_in_sync",
  MOVE_TAB = "report_move_tab",
}
